import { render, staticRenderFns } from "./emailTemplates.vue?vue&type=template&id=16bf972a&scoped=true&"
import script from "./emailTemplates.vue?vue&type=script&lang=js&"
export * from "./emailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplates.vue?vue&type=style&index=0&id=16bf972a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf972a",
  null
  
)

export default component.exports